import useTranslation from '@/utils/hooks/translation/useTranslation';

import Icon from '@/components/base/Icon';

export const SocialInboxTitle = () => {
    const { t } = useTranslation('conversations');

    return (
        <div className="flex items-center space-x-2 text-icoBlack dark:text-white">
            <Icon icon="inbox" className="text-16" />
            <span>{t('social_inbox.title')}</span>
        </div>
    );
};
